export default __webpack_public_path__ + "static/media/inside.6709ba1b.jpg";